import Configuration from '@/agilis/util/Configuration'
import { mapGetters } from 'vuex'
import actionsMixin from '@/applications/scrum/mixins/actionsMixin'

export default {
  name: 'TrackerDataTableItemActions',
  mixins: [actionsMixin],

  props: {
    trackerDTO: {
      type: Object,
      default: () => ({})
    },
    jlAssertionContext: {
      type: Object,
      default: () => ({})
    }
  },

  components: {
    StateGraph: () => import(/* webpackChunkName: "state-graph" */'@/agilis/components/Graph/StateGraph/StateGraph.vue')
  },

  data () {
    return {
      workflow: false
    }
  },

  created () {
  },

  computed: {
    ...mapGetters({
      selectedContext: 'contextStore/selectedContext',
      userId: 'userDataStore/userId'
    })
  },

  methods: {
    userCanAccessFeature (featureId) {
      return Configuration.auth.userCanAccessFeature(
        this.selectedContext, featureId, null, this.trackerDTO, this.userId)
    },

    disabledMessage (actionArray) {
      return actionArray.find(action => action.errorMessage)?.errorMessage
    },

    displayNoActionMessage () {
      const trackerStateLabel = this.$t(Configuration.state.getTrackerStatesMap(this.trackerDTO)[this.trackerDTO.state]?.label)
      return this.$t('message.noAction', { stateLabel: ` ${trackerStateLabel}` })
    }
  }
}
